import { useMemo } from 'react';
import { TimeSignal } from 'graphql/types';

type useNotesGroupedByDayProps = {
  notes: TimeSignal[];
};

const groupNotesByDay = (notes: TimeSignal[]): Record<string, TimeSignal[]> => {
  const notesGroupedByDay = new Map<string, TimeSignal[]>();

  notes.forEach((note: TimeSignal) => {
    const noteDate = note.date as string;
    const groupToBeModified = notesGroupedByDay.get(noteDate);
    if (groupToBeModified) {
      notesGroupedByDay.set(noteDate, [...groupToBeModified, note]);
    } else {
      notesGroupedByDay.set(noteDate, [note]);
    }
  });

  return Object.fromEntries(notesGroupedByDay);
};

export const useNotesGroupedByDay = ({
  notes
}: useNotesGroupedByDayProps): Record<string, TimeSignal[]> => {
  return useMemo(() => groupNotesByDay(notes), [notes]);
};
